import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OAuthModule } from 'angular-oauth2-oidc';
import { SharedAuthRoutingModule } from './shared-auth-routing.module';
import { SharedAuthWrapperComponent } from '../components/shared-auth-wrapper/shared-auth-wrapper.component';
import { TestAuth0Component } from '../components/test-auth0/test-auth0.component';
import { TestAuth2Component } from '../components/test-auth2/test-auth2.component';

@NgModule({
  declarations: [
    SharedAuthWrapperComponent,
    TestAuth2Component,
    TestAuth0Component
  ],
  imports: [
    CommonModule,
    SharedAuthRoutingModule,
    //OAuthModule.forRoot(),
  ],
})
export class SharedAuthModule {}
